export default {
  'ihut-1': '/assets/images/ihut/Image-IHUT-1.png',
  'ihut-2': '/assets/images/ihut/Image-IHUT-2.png',
  'ihut-3': '/assets/images/ihut/Image-IHUT-3.png',
  'ihut-4': '/assets/images/ihut/Image-IHUT-4.png',
  'ihut-5': '/assets/images/ihut/Image-IHUT-5.png',
  'ihut-6': '/assets/images/ihut/Image-IHUT-6.png',
  'ihut-7': '/assets/images/ihut/Image-IHUT-7.png',
  'ihut-8': '/assets/images/ihut/Image-IHUT-8.png'
} as const;
